import * as actionTypes from "./actionTypes";
import * as actions from "./actions";
import * as typings from "./typings";

export const modalActionTypes = actionTypes;
export const modalActions = actions;
export const modalTypings = typings;
